class MuMobileMenuDrawer extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.openTrigger = document.querySelector('[data-action="open-mu-mobile-menu-drawer"]');
        this.closeTrigger = this.querySelector('#mu-mobile-menu-drawer-close-button');
        this.pageOverlay = this.querySelector('#mu-mobile-menu-drawer__overlay');

        this.openTrigger?.addEventListener('click', this.open.bind(this));
        this.closeTrigger?.addEventListener('click', this.close.bind(this));
        this.pageOverlay?.addEventListener('click', this.close.bind(this));
        window.addEventListener('resize', this.resize.bind(this));
        document.addEventListener('keydown', this.handleKeyDown.bind(this));
    }
    open() {
        this.setAttribute("open", "");
        this.pageOverlay?.setAttribute("aria-hidden", "false");
        document.documentElement.setAttribute("scroll-lock", "");

        // Move focus into the drawer, preferably to the close button
        if (this.closeTrigger instanceof HTMLElement) {
            this.closeTrigger.focus();
        }
    }
    close() {
        this.removeAttribute("open");
        this.pageOverlay?.setAttribute("aria-hidden", "true");
        document.documentElement.removeAttribute("scroll-lock");
        // Close any open accordions
        // this.querySelectorAll('details[open]').forEach((details) => {
        //     details.removeAttribute('open');
        //     details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        //   });
    }
    resize() {
        this.style.setProperty('--drawer-height', `${window.innerHeight}px`);
        if (this.hasAttribute('open')) {
            this.close();
            document.documentElement.removeAttribute("scroll-lock");
        }
    }
    handleKeyDown(event) {
        if (event.key === 'Escape' && this.hasAttribute('open')) {
            this.close();
            document.documentElement.removeAttribute("scroll-lock");
        }
    }
}

customElements.define('mu-mobile-menu-drawer', MuMobileMenuDrawer);